import PersonIcon from "@mui/icons-material/Person";
import { Button, DialogContentText, Typography, useTheme } from "@mui/material";
import { Dialog } from "components/Dialog";
import { ActivityStatus, ExecutionPlanType } from "generated-graphql/graphql";
import { useUpdateActivity } from "hooks/activities";
import { useCallback, useState } from "react";
import { ActivityButtonProps } from ".";

export const SetToManual = ({ activity, refetchQueries }: ActivityButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const canSetToManual =
    activity.executionPlan !== ExecutionPlanType.Human &&
    activity?.status !== ActivityStatus.Completed;
  if (canSetToManual) {
    return (
      <>
        <Button
          variant="text"
          size="small"
          color="primary"
          loadingPosition="start"
          onClick={() => setIsDialogOpen(true)}
          startIcon={<PersonIcon />}
          sx={{ minWidth: 120 }}
        >
          Set to manual
        </Button>
        <SetToManualDialog
          activityId={activity.id}
          status={activity.status}
          isOpen={isDialogOpen}
          closeDialog={() => setIsDialogOpen(false)}
          refetchQueries={refetchQueries}
        />
      </>
    );
  } else {
    return null;
  }
};

interface Props {
  activityId: string;
  status: ActivityStatus;
  closeDialog: () => void;
  isOpen: boolean;
  refetchQueries?: string[];
}

const SetToManualDialog = ({
  activityId,
  status,
  isOpen,
  closeDialog,
  refetchQueries,
}: Props) => {
  const theme = useTheme();
  const [updateActivity, { loading: isActivityUpdating }] = useUpdateActivity(refetchQueries);
  const handleSetToManualButtonClick = useCallback(async () => {
    updateActivity({
      variables: {
        id: activityId,
        input: {
          executionPlan: ExecutionPlanType.Human,
        },
      },
    });
    closeDialog();
  }, [activityId, closeDialog, updateActivity]);

  return (
    // Should this use Confirm dialog?
    <Dialog
      open={isOpen}
      title="Set Activity to Manual"
      onClose={closeDialog}
      primaryActionButtonProps={{
        loading: isActivityUpdating,
        onClick: handleSetToManualButtonClick,
        saveText: "Set to manual",
        startIcon: null,
      }}
    >
      <DialogContentText>
        Are you sure you want to set this activity to manual?
        {status === ActivityStatus.InProgress && (
          <Typography>
            In Progress portal automation will be canceled. Logout could take up
            to 10 minutes.
          </Typography>
        )}
      </DialogContentText>
    </Dialog>
  );
};
